/**
 * This function's arguments are loosely typed because the type checking should
 * be done by other code.
 */
export function formatPathParams(pathPattern, params) {
  return pathPattern.replaceAll(/[:*][^&/.-]+/gu, match => {
    const isWildcard = match.startsWith('*');
    const paramName = match.slice(1);
    if (params === undefined || !(paramName in params)) {
      console.error('Missing path parameter:', paramName);
      return 'null';
    }
    const paramValue = params[paramName];
    if (isWildcard) {
      if (!Array.isArray(paramValue)) {
        console.error('Wildcard param values must be arrays');
        return encodeURIComponent(String(paramValue));
      }
      return paramValue.map(x => encodeURIComponent(String(x))).join('/');
    } else {
      return encodeURIComponent(String(paramValue));
    }
  });
}